/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    'use strict';
    /*globals Tc */

    /**
     * ImageMapContainer
     *
     * @author Zeljko Curcic
     * @namespace Tc.Module
     * @class ImageMapContainer
     * @extends Tc.Module
     */

    Tc.Module.ImageMapContainer = Tc.Module.extend({

        on: function(callback) {
            this.$items = this.$ctx.find('.modImageMapItem');
            this.$defaultItem = this.$ctx.find('.item-default').length ? this.$ctx.find('.item-default').eq(0) : this.$items.eq(0).addClass('item-default');
            this.$areaContainer = this.$ctx.find('.area-container');

            this.$ctx.find('.item-default').removeClass('hidden');
            this.setupImageMap();

            this.$areaContainer.find('.image-map-area:first').addClass('first');

            this.$ctx.on('click', '.area-container > .image-map-area', $.proxy(this.mouseEnterHandler, this));

            this.$ctx.on('click', '.area-container > .image-map-area', this.imageMap);

            callback();
        },

        mouseEnterHandler: function(e) {
            var $activeArea = $(e.currentTarget),
                idx = $activeArea.index();

            if (!(this.$items.eq(idx).hasClass('hidden'))) {
                this.$items.addClass('hidden');
                this.$defaultItem.removeClass('hidden');
            } else {
                this.$items.addClass('hidden');
                this.$items.eq(idx).removeClass('hidden');
            }

            this.fire('toggleVisibility', {}, ['brightcovecontrol']);
        },

        setupImageMap: function() {
            var i, $item, $area,
                ii = this.$items.length;
            if (ii > 1) {
                for (i = 0; i < ii; i += 1) {
                    $item = this.$items.eq(i);
                    $area = $('<div class="image-map-area"><div class="button"></div></div>').css({
                        'left': $item.data('left'),
                        'top': $item.data('top'),
                        'width': $item.data('width'),
                        'height': $item.data('height')
                    });
                    $area.appendTo(this.$areaContainer);
                }
            } else {
                this.$items.removeClass('hidden');
            }
            var $button = this.$ctx.find('.button');

            if (this.$ctx.data('disable')) {
                $button.css('opacity', '0');
            } else {
                $button.css('opacity', '1');
            }
        },

        imageMap: function() {
            var $button = $(this).find(".button");
            if ($button.hasClass('clicked')) {
                $button.removeClass('clicked');
            } else {
                $button.addClass('clicked').parent().siblings().find('.button').removeClass('clicked');
            }
        }

    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapContainer.js
// module id = 146
// module chunks = 0